import styled from '@emotion/styled';

export const SCustomize = styled.div`
  .custom-ant-tabs {
    .ant-tabs-ink-bar {
      background-color: rgba(0, 0, 0, 0.85);
    }
    .ant-tabs-tab {
      &.ant-tabs-tab-active {
        opacity: 1;
        .ant-tabs-tab-btn {
          color: rgba(0, 0, 0, 0.85);
          outline: rgba(0, 0, 0, 0.85);
        }
      }
      opacity: 0.5;
      .ant-tabs-tab-btn {
        color: rgba(0, 0, 0, 0.85);

        &:hover,
        &:active,
        &:focus {
          color: rgba(0, 0, 0, 0.85);
          opacity: 1;
        }
      }
    }
  }
`;
